export default "__VITE_ASSET__DjTqyulr__"